import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import EditIcon from '@components/basics/icons/edit';

interface EditButtonProps {
  className?: string;
  onClick?: () => void;
}

const EditButton: FunctionComponent<EditButtonProps> = ({
  className,
  onClick,
}) => {
  return (
    <div className={className || ''} onClick={onClick}>
      <EditIcon />
    </div>
  );
};

export default styled(EditButton)`
  background-color: ${({ theme }) => theme.colors.differentBackground};
  border-radius: 16px;
  padding: 10px 16px;
  max-width: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};
  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
  }
`;
